import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { RemoteObjectSuggestionCountQuery } from '../src/hooks/useFetchSuggestionCount.ts';
import type {
	useFetchSuggestionCountQuery$data,
	useFetchSuggestionCountQuery$variables,
} from '../src/hooks/__generated__/useFetchSuggestionCountQuery.graphql.ts';

export function preloadSuggestionCount(spaceKey: string, cloudId: string): Promise<any> {
	return queryAgg<useFetchSuggestionCountQuery$data, useFetchSuggestionCountQuery$variables>({
		query: RemoteObjectSuggestionCountQuery,
		variables: { cloudId, spaceKey },
	});
}
